import { render, staticRenderFns } from "./ResidentList.vue?vue&type=template&id=82eef534"
import script from "./ResidentsList.ts?vue&type=script&lang=ts&external"
export * from "./ResidentsList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports